import React, { useState } from "react";
import StationsPage from "../features/stations/StationsPage";
import AddStationFlow from "../features/stations/AddStationFlow";
import "../features/stations/stations.scss";
import Sidebar from "../components/layout/Sidebar";
import Header from "../components/layout/Header";
import { Plus } from "lucide-react";

const Stations: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showAddStationFlow, setShowAddStationFlow] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };
  return (
    <div className="stations-route-container">
      <Sidebar className={isSidebarOpen ? "open" : ""} />
      {isSidebarOpen && <div className="overlay" onClick={closeSidebar} />}
      <div className="stations-content">
        {!showAddStationFlow && (
          <Header
            onMenuClick={toggleSidebar}
            // rightActions={
            //   <div className="actions tooltip-wrapper">
            //     <button className="add-btn disable-btn" disabled>
            //       <Plus size={18} /> Add Station
            //     </button>
            //     <span className="tooltip-text">Coming Soon</span>
            //   </div>
            // }
          />
        )}
        {showAddStationFlow ? (
          <AddStationFlow onBack={() => setShowAddStationFlow(false)} />
        ) : (
          <StationsPage />
        )}
      </div>
    </div>
  );
};

export default Stations;
